module.exports = __webpack_public_path__ + "3af3fff8198e28584454fa12a6a2a6ff.png";